import { Button, Form } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import type { UseDownloadMediaPayload } from '@modals/DownloadMediaModal/hooks/useDownloadMedia'
import type { AgencyModel } from '@models/types'
import type { ActionResult } from '@redux/modules/module'

interface CustomSizeFormProps {
  callbacks: {
    updateAgency: (payload: HandleCallbackActionParams) => Promise<ActionResult<AgencyModel>>,
  },
  downloadMediaPayload: UseDownloadMediaPayload,
}

const saveCustomSize = (params: CustomSizeFormProps) => {
  const { callbacks: { updateAgency }, downloadMediaPayload } = params

  const {
    callbacks: {
      buildAgencyPresets, buildCustomPreset, setState, updateAgency: updateFn,
    },
    presetForm: { entityState },
  } = downloadMediaPayload

  const customPreset = buildCustomPreset(entityState)

  const downloadImagesPayload = {
    callbacks: {
      action: updateFn,
      // @ts-expect-error TS2322
      afterAction: () => setState({ selectedPreset: customPreset, showCustomSizeForm: false }),
    },
    // @ts-expect-error TS2345
    entityParams: buildAgencyPresets(customPreset),
    toastText: 'Download Preset Added',
  }

  updateAgency(downloadImagesPayload)
}

const CustomSizeForm = (props: CustomSizeFormProps) => {
  const { downloadMediaPayload } = props

  const {
    callbacks: { setState },
    presetForm,
    updatingAgency,
  } = downloadMediaPayload

  const {
    entityState: {
      height,
      title,
      width,
    },
    errors,
    handlers,
    saveEnabled,
  } = presetForm

  return (
    <Form marginTop="large">
      <Form.Field errorMessage={errors.title} label="* Custom Preset Name">
        <input name="title" type="text" value={title} {...handlers} />
      </Form.Field>

      <Form.Row marginTop="large">
        <Form.Field errorMessage={errors.width} label="* Width">
          <input name="width" type="number" value={width} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field errorMessage={errors.height} label="* Height" marginTop={['large', 0]}>
          <input name="height" type="number" value={height} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Button
        buttonStyle="primaryCreate"
        disabled={!saveEnabled}
        loading={updatingAgency}
        marginTop="large"
        onClick={() => saveCustomSize(props)}
        size="medium"
      >
        {saveEnabled ? 'Save Custom Size' : 'Complete Fields'}
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        marginTop="medium"
        onClick={() => setState({ showCustomSizeForm: false })}
        size="medium"
      >
        Hide Custom Size Form
      </Button>
    </Form>
  )
}

export default CustomSizeForm
